import {
  AppDispatch,
  createKitDevice,
  createKitDeviceClear,
  createKitDeviceRequest,
  getDeviceList,
  getDeviceListRequest,
  getKitList } from
"@src/redux";
import { Form, Select, Row, Col, Button } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

type Props = {
  handleCancel: any;
  mutationType: string;
  modalType: string;
  kit?: any;
  getKitLists: any;
  deviceKit: string;
  deviceType: string;
};

const ClientDeviceKitForm = (props: Props) => {
  const { handleCancel, modalType, getKitLists, deviceKit, deviceType } =
  props;
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [deviceItems, setDeviceItems] = useState([]);

  const { result, loading, error } = useSelector(createKitDevice);
  const { result: getAllDeviceItems } = useSelector(getDeviceList);
  const { result: kit } = useSelector(getKitList);

  useEffect(() => {
    let temp: any = [];
    if (getAllDeviceItems?.items) {
      temp = getAllDeviceItems?.items.map((item) => ({
        label: `${item.referenceId} - ${item.brand?.name}`,
        value: item.id
      }));
      setDeviceItems(temp);
    }
  }, [getAllDeviceItems]);

  useEffect(() => {
    if (result?.status === "success") {
      toast.success("Device assigned successfully");
      getKitLists();
      dispatch(createKitDeviceClear());
      handleCancel();
    } else if (result?.error?.message) {
      toast.error(result.error.message);
      dispatch(createKitDeviceClear());
    } else if (error?.message) {
      toast.error(error.message);
      dispatch(createKitDeviceClear());
    }
  }, [result, error]);

  const handleSubmit = (values: any) => {
    dispatch(
      createKitDeviceRequest({
        data: {
          kitId: deviceKit,
          deviceId: values.deviceId
        }
      })
    );
  };
  useEffect(() => {
    dispatch(
      getDeviceListRequest({
        filter: {
          status: "free",
          type: deviceType
        }
      })
    );
  }, [deviceType]);

  return (
    <Form layout="vertical" onFinish={handleSubmit} form={form}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={t("device")}
            name="deviceId"
            rules={[{ required: true, message: t("device_is_required") }]}>
            
            <Select
              placeholder={t("select_device")}
              options={deviceItems}
              showSearch
              allowClear
              filterOption={(input, option) => {
                if (!option) return false; // safeguard for undefined
                const opt = option as unknown as {
                  label?: string;
                  value?: string;
                };
                return (opt.label ?? "").
                toLowerCase().
                includes(input.toLowerCase());
              }}
              filterSort={(optionA, optionB) => {
                const a = (
                (optionA as unknown as {label?: string;}).label ?? "").
                toLowerCase();
                const b = (
                (optionB as unknown as {label?: string;}).label ?? "").
                toLowerCase();
                return a.localeCompare(b);
              }} />
            
          </Form.Item>
        </Col>
        {/* <Col span={24}>
           <Form.Item label={t("remarks")} name={"remarks"}>
             <Input />
           </Form.Item>
          </Col> */}
      </Row>

      <div className="kit-edit-modal-footer">
        <Button onClick={handleCancel} danger>
          {t("close")}
        </Button>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button htmlType="submit" type="primary" loading={loading}>
            {t("add")}
          </Button>
        </Form.Item>
      </div>
    </Form>);

};

export default ClientDeviceKitForm;